// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"63a4b981","232":"2ab67488","237":"b2c7a1ef","526":"369ddfc5"}[chunkId] + ".chunk.js";
};